import {
  authenticatedApplicantContext,
  authenticatedUser,
  authentication,
  unAuthenticatedUser
} from 'src/utilities/storage';
import CookieLocalStorage from 'src/features/Auth/Login/CookieLocalStorage';

export const clearLocalStorage = () => {
  clearAuthenticatedSessions();
  clearUnAuthenticatedSessions();
  CookieLocalStorage.deleteUser();
  unAuthenticatedUser.advisorUsername.remove();
};

const clearAuthenticatedSessions = () => {
  authentication.token.set(null);
  authentication.expire.set(null);

  authenticatedApplicantContext.loansContext.set(null);
  authenticatedApplicantContext.currentLoanRoleContext.set(null);
  authenticatedApplicantContext.applicantContext.set(null);


  authenticatedUser.accountId.set(null);
  authenticatedUser.rolesId.set(null);
  authenticatedUser.loggedInRole.set(null);
  authenticatedUser.accountEmail.set(null);
  authenticatedUser.accountTimeZone.set(null);
  authenticatedUser.accountName.set(null);
}

const clearUnAuthenticatedSessions = () => {
  unAuthenticatedUser.workFlowIntent.set(null)
  unAuthenticatedUser.inviteParams.set(null)
  unAuthenticatedUser.leadUID.set(null)
  unAuthenticatedUser.productType.set(null);
  unAuthenticatedUser.advisorUsername.set(null);
  unAuthenticatedUser.aliasName.set(null);
  unAuthenticatedUser.loanType.set(null);
  unAuthenticatedUser.signupType.set(null);
  unAuthenticatedUser.userType.set(null);

}
